import { Component, SimpleChanges, OnChanges, Input } from '@angular/core';
import emailMisspelled, { top100, hotmail } from './email-misspelled';
import { ngHelper } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-email-misspelled',
  templateUrl: './ui-email-misspelled.component.html',
  styleUrls: ['./ui-email-misspelled.component.scss']
})
export class UiEmailMisspelledComponent implements OnChanges {
  @Input() email: string;
  public corrected: string = null;

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'email', email => {
      this._emailCheck(email);
    });
  }

  private _emailCheck(email) {
    const emailChecker = emailMisspelled({ domains: [...top100, ...hotmail] });
    const suggest = emailChecker(email);
    this.corrected = suggest && suggest.length ? suggest[0].corrected : '';
  }
}
